import React from 'react';
import { Link } from 'react-router-dom';

// Libraries
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import left_image from '../../assets/images/cta-one-bg-shape.png'
import right_image from '../../assets/images/request-shape-1.png'

// Site Data


// SCSS
import './page-header.css';

function PageHeader(props) {
  return (
    <div
      className={`page-header ${props.bgImageHide ? 'bg-hide' : ''} theme-${
        props.theme
      }`}
      style={
        props.bgImageHide
          ? null
          : {
              backgroundImage: `linear-gradient(to right, #0A940B 30%, #EBB51C)`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
            }
      }
    >
        <div className="right_image">
            <img src={left_image} alt="" />
        </div>
        <div className="left_image_one" >
            <img src={right_image} alt="" />
        </div>
      {props.bgImageHide ? null : (
        <div
          className="page-header-overlay"
          style={props.overlay ? { backgroundColor: props.overlay } : null}
        ></div>
      )}
      <div className="page-header-wrapper">
        <Container>
          <Row className="d-flex justify-content-start">
            <div className={props.colSize || 'col-md-10 col-12'}>
              <div className="page-header-inner">
                {props?.breadCrumbItems && (
                  <ul className="page-breadcrumbs">
                    {props.breadCrumbItems.map((item, index) => {
                      return item.active ? (
                        <li key={index} className="breadcrumb-item active">
                          {item.label}
                        </li>
                      ) : (
                        <li key={index} className="breadcrumb-item">
                          <Link to={item.path}>{item.label}</Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
                <div className="page-header-title mt-1 first-letter-capitalize">{props.title}</div>
                {props?.description && <p>{props.description}</p>}
                
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default PageHeader;
